import React, { Children } from 'react';
import styled from 'styled-components';

interface Props {
  children?: React.ReactNode;
  separator?: React.ReactNode;
}

/**
 * A Component that joins it's children by inserting a separator between them
 */
export const Join = (props: Props): JSX.Element => {
  const children = Children.toArray(props.children);

  return (
    <>
      {children.reduce<React.ReactNode[]>((acc, child, index) => {
        if (index > 0) {
          return acc.concat(
            <Separator key={`separator-${index}`}>{props.separator}</Separator>,
            <Element key={`element-${index}`}>{child}</Element>
          );
        }

        return acc.concat(<Element key={`element-${index}`}>{child}</Element>);
      }, [])}
    </>
  );
};

const Separator = styled.span``;

const Element = styled.span`
  &:empty + ${Separator} {
    display: none;
  }
`;
